import React,{Fragment} from "react"
import ListItem from '@material-ui/core/ListItem'
import { withStyles } from '@material-ui/core/styles'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import Icon from '@material-ui/core/Icon'
import { withTheme } from '@material-ui/core/styles'
import moment from 'moment'
import Grid from '@material-ui/core/Grid'
import { I18n } from 'react-redux-i18n'


const styles = theme => ({
  mainList:{
    width: '100%',
    color: '#009fe3',
    padding: '12px 0'
  },
  mainListIcon: {
    display: 'inline-block'
  },
  mainListText: {
    display: 'inline-block'
  },
  button: {
    margin: 0,
  },
  icon: {
    height: '1.4em',
    lineHeight: '1.4em',
    fontSize: '2em'
  },
  secondaryItem:{
    marginLeft: 10,
    display: 'inline-block',
  },
  primaryItem:{
    width: '90px',
    display: 'inline-block',
  }
});

class PrivateAppointment extends React.Component {

  render(){
    return(
      <Fragment>
        <ListItem>
          <MainList appointment={this.props.appointment} selectedDate={this.props.selectedDate} classes={this.props.classes} />
        </ListItem>
        <Divider />
      </Fragment>
    )
  }
}

function MainList(props){
  let timeItem = null
  let fromItem = null

  const begin = moment(props.appointment.van_datum+props.appointment.van_tijd, 'YYYYMMDDhhmm')
  const end = moment(props.appointment.tot_datum+props.appointment.tot_tijd, 'YYYYMMDDhhmm')

  if(props.appointment.van_datum === props.appointment.tot_datum){
    timeItem = <span className={props.classes.primaryItem}>{props.appointment.van_tijd + " - " + props.appointment.tot_tijd}</span>
  }else{
    if(props.selectedDate.diff(moment(props.appointment.van_datum, 'YYYYMMDD'), 'days') === 0){
      timeItem = <span className={props.classes.primaryItem}>{props.appointment.van_tijd + " - 24:00"}</span>
    }else if(props.selectedDate.diff(moment(props.appointment.tot_datum, 'YYYYMMDD'), 'days') === 0){
      timeItem = <span className={props.classes.primaryItem}>{"00:00 - " + props.appointment.tot_tijd}</span>
    }else if(props.selectedDate.diff(moment(props.appointment.van_datum, 'YYYYMMDD'), 'days') > 0
      && props.selectedDate.diff(moment(props.appointment.tot_datum, 'YYYYMMDD'), 'days') < 0){
      timeItem = <span className={props.classes.primaryItem}>{I18n.t('appointments.wholeDay')}</span>
    }
  }

  if(props.appointment.van_datum === props.appointment.tot_datum){
    if(moment(props.appointment.van_datum+props.appointment.van_tijd, 'YYYYMMDDhhmm').diff(moment()) <= 0 && moment(props.appointment.tot_datum+props.appointment.tot_tijd, 'YYYYMMDDhhmm').diff(moment()) >= 0){
      fromItem = <span className={props.classes.secondaryItem}>{I18n.t('appointments.now')}</span>
    }else if(moment(props.appointment.van_datum+props.appointment.van_tijd, 'YYYYMMDDhhmm').diff(moment()) < 0){
      fromItem = <span className={props.classes.secondaryItem}>{moment(props.appointment.tot_datum+props.appointment.tot_tijd, 'YYYYMMDDhhmm').fromNow()}</span>
    }else{
      fromItem = <span className={props.classes.secondaryItem}>{moment(props.appointment.van_datum+props.appointment.van_tijd, 'YYYYMMDDhhmm').fromNow()}</span>
    }
  }else{
    if(moment().diff(begin, 'days') === 0 && begin.diff(moment()) >= 0){
      fromItem = <span className={props.classes.secondaryItem}>{begin.fromNow()}</span>
    }else if(moment().diff(end, 'days') === 0 && end.diff(moment()) <= 0){
      fromItem = <span className={props.classes.secondaryItem}>{end.fromNow()}</span>
    }else{
      fromItem = <span className={props.classes.secondaryItem}>{I18n.t('appointments.now')}</span>
    }
  }

  return(
    <div onClick={props.onClick} className={props.classes.mainList}>
      <Grid container justify="center" >
        <Grid item container xs={2} md={1}>
          <Icon className={props.classes.icon}>
              timelapse
          </Icon>
        </Grid>
        <Grid item container xs={10} md={11}>
          <ListItemText
            primary={
              <span>
                {I18n.t('appointments.private')}
              </span>
            }
            secondary={
              <span>
                {timeItem}
                {fromItem}
              </span>
            }
            className={props.classes.mainListText}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default withTheme()(withStyles(styles)(PrivateAppointment))



// WEBPACK FOOTER //
// ./src/js/components/pages/appointment/PrivateAppointment.js